export const replaceJwtSpecialSymb = (line: string) => {
    return line.replaceAll('=', '')
               .replaceAll('+', '-')
               .replaceAll('/', '_');
}